module.exports = __webpack_public_path__ + "media/images/amazon_small_logo-25dcd7d06fcc61bb9d24827bf4cf666f.png";